export const blockIconsHouseholdElectricBoltNew = (
	<span className='material-symbols-outlined'>electric_bolt</span>
);
